import * as React from "react";

import { PostFeedItem } from "../../../../../models";
import Tile from "./Tile";

import "../../../../../../common/components/feed/styles/windowFeed.sass";

const Window: React.FunctionComponent<ComponentProps> = props => {
  return (
    <div className="window">
      {props.postsFeed.map(post => <Tile key={post.id} {...props} post={post} />)}
    </div>
  );
}

interface ComponentProps {
  cardCount: number;
  hidePublishTime?: boolean;
  hideStats?: boolean;
  hideSummary?: boolean;
  postsFeed: PostFeedItem[];
  preferredLCID: string;
  onPostSelected: (post: PostFeedItem) => void;
}

export default Window;